import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import TrackingSection from './components/TrackingSection';
import BenefitsSection from './components/BenefitsSection';
import TestimonialsSection from './components/TestimonialsSection';
import ComplianceAuditSection from './components/ComplianceAuditSection';
import ContactSection from './components/ContactSection';

const PharmaciesPageES = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Set language to Spanish when this page loads
    i18n.changeLanguage('es');
    
    // Update document title and meta tags for Spanish
    document.title = 'Contabilidad Especializada para Farmacias | LedgRkeepR';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Servicios de contabilidad especializados para farmacias independientes. Cumplimiento HIPAA, seguimiento de sustancias controladas, reconciliación de seguros y más.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'contabilidad farmacia, servicios financieros farmacia, cumplimiento HIPAA, sustancias controladas, reconciliación seguros');
    }
  }, [i18n]);

  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <ServicesSection />
      <TrackingSection />
      <BenefitsSection />
      <TestimonialsSection />
      <ComplianceAuditSection />
      <ContactSection />
    </div>
  );
};

export default PharmaciesPageES;